import { z } from 'zod';
import { c } from '../contract';
import { sessionInfoSchema } from '../schemas';

export const sessionRouter = c.router(
  {
    refresh: {
      summary: 'Refresh user session',
      method: 'POST',
      path: '/refresh',
      body: z.object({
        visitorId: z.string(),
        initialSessionInfo: sessionInfoSchema.optional(),
        source: z.string(),
      }),
      responses: {
        200: z.literal('ok'),
      },
    },
    bootstrap: {
      summary: 'Resolve per-visitor identity for client hydration (DEV-5533 cached anon shell)',
      method: 'GET',
      path: '/bootstrap',
      responses: {
        200: z.object({
          user: z.object({
            uid: z.string(),
            isAnonymous: z.boolean(),
            isAuthenticated: z.boolean(),
          }),
          visitorId: z.string(),
          sessionInfo: sessionInfoSchema,
          isEU: z.boolean(),
        }),
      },
    },
  },
  { pathPrefix: '/session' },
);
